import frankensteinPDF from '../files/Frankenstein-1994.pdf';
import frankenstein from '../files/Франкенштейн.txt';

export default function Footer() {
  return (
    <footer>
      <ul className="FileLinks">
        <li>
          <a href={frankenstein} download>TXT версия</a>
        </li>
        <li>
          <a href={frankensteinPDF} download>PDF на английском</a>
        </li>
      </ul>
      <a className="Logo-link" target="_blank" rel="noreferrer" href="https://www.flamingmachine.ru">
        <div className="Logo-wrapper">
          <div className="Logo" />
        </div>
      </a>
    </footer>
  );
}